export function calculateLaengsteSeite(seiten) {
  var laengsteSeite = seiten;
  laengsteSeite.sort(function(a, b){return b-a});
  return laengsteSeite[0];
}

export function calculateFlaecheLueftungskanal({
  Lueftungskanalbreite,
  Lueftungskanalhoehe,
  Lueftungskanallaenge,
  Lueftungskanellaenge,
}) {
  return ((Lueftungskanalbreite/1000 + Lueftungskanalhoehe/1000) * 2 * (Lueftungskanallaenge || Lueftungskanellaenge)/1000);
}

export function calculateBlechdicke({
  Lueftungskanalbreite,
  Lueftungskanalhoehe,
  Lueftungskanallaenge,
  Lueftungskanellaenge,
  Druckbereich,
}) {
  var laengsteSeite = calculateLaengsteSeite([Lueftungskanalbreite, Lueftungskanalhoehe, Lueftungskanallaenge || Lueftungskanellaenge]);

  switch (Druckbereich) {
    case "ND" :
      if(laengsteSeite <= 500){
        return 5.6;
      }
      else if(laengsteSeite > 500 && laengsteSeite <=1000) {
        return 6.4;
      }
      else if(laengsteSeite >1000 && laengsteSeite <= 2000) {
        return 8.0;
      }
      else if(laengsteSeite >2000 && laengsteSeite <=3000){
        return 8.8;
      }
      else if(laengsteSeite >3000){
        return 9.6;
      }
      break;
    case "MD" :
      if(laengsteSeite <= 530){
        return 5.6;
      }
      else if(laengsteSeite > 530 && laengsteSeite <=1000) {
        return 7.2;
      }
      else if(laengsteSeite >1000 && laengsteSeite <= 2000) {
        return 8.8;
      }
      else if(laengsteSeite >2000 && laengsteSeite <=3000){
        return 9.6;
      }
      else if(laengsteSeite >3000){
        return 9.6;
      }
      break;
    case "HD":
      if(laengsteSeite <= 500){
        return 12.0;
      }
      else if(laengsteSeite > 500 && laengsteSeite <=1000) {
        return 12.0;
      }
      else if(laengsteSeite >1000 && laengsteSeite <= 2000) {
        return 16.0;
      }
      else if(laengsteSeite >2000 && laengsteSeite <=3000){
        return 24.0;
      }
      else if(laengsteSeite >3000){
        return 24.0;
      }
      break;
    default:
      if(laengsteSeite <= 500){
        return 12.0;
      }
      else if(laengsteSeite > 500 && laengsteSeite <=1000) {
        return 12.0;
      }
      else if(laengsteSeite >1000 && laengsteSeite <= 2000) {
        return 16.0;
      }
      else if(laengsteSeite >2000 && laengsteSeite <=3000){
        return 24.0;
      }
      else if(laengsteSeite >3000){
        return 24.0;
      }
      break;
  }
}

export function calculateLueftungsgehaeusegewicht(props) {
  var masseKanal = calculateFlaecheLueftungskanal(props) * calculateBlechdicke(props);
  return masseKanal;
}

export function calculateVolumenMineralwolle({ Kulissenbreite, Kulissenhoehe, Kulissenlaenge }) {
  let vol_Mineralwolle = ((Kulissenbreite / 1000) * (Kulissenhoehe / 1000) * (Kulissenlaenge / 1000));
  return vol_Mineralwolle;
}

export function calculateRohdichteMineralwolle() {
  return 33;
}

export function calculateMasseMineralwolle(props) {
  let masse_Mineralwolle;
  let rohdichte_Mineralwoll = calculateRohdichteMineralwolle();
  masse_Mineralwolle = rohdichte_Mineralwoll * calculateVolumenMineralwolle(props);
  return masse_Mineralwolle.toFixed(2);
}

export function calculateRKulissenblech({ Kulissenbreite }) {
  switch(Kulissenbreite) {
    case 100:
      return 0.72;
    case 150:
      return 0.96;
    case 200:
      return 1.20;
    case 230:
      return 1.35;
    case 300:
      return 1.68;
    case 350:
      return 1.92;
    default:
      return 1.92;
  }
}

export function calculateMasseKulissenrahmen(props) {
  let masse_kulissenrahmen = (props.Kulissenhoehe/1000 + props.Kulissenlaenge/1000)*2*calculateRKulissenblech(props);
  return masse_kulissenrahmen;
}

export function calculateLaengeStreben({ Kulissentyp, Kulissenhoehe, Kulissenlaenge }) {
  switch (Kulissentyp) {
    case "HKS":
    case "HKL":
    case "HKRR":
      return Math.floor((Kulissenhoehe*Kulissenlaenge)/1000000)*2*Kulissenhoehe/1000;
    case "HKR":
    case "HKRL":
      return Math.ceil((Kulissenhoehe*Kulissenlaenge)/1000000)*2*Kulissenhoehe/1000;
    default:
      return Math.ceil((Kulissenhoehe*Kulissenlaenge)/1000000)*2*Kulissenhoehe/1000;
  }
}

export function calculateGewichtStreben() {
  return 0.48;
}

export function calculateMasseStreben(props) {
  let _masse_Streben = calculateLaengeStreben(props) * calculateGewichtStreben();
  return _masse_Streben;
}

export function calculateMasseResonanzblech({ Kulissenhoehe, Kulissenlaenge }) {
  return ((Kulissenhoehe/1000)*(Kulissenlaenge/1000) * 4.8);
}

export function calculateMasseLochblech({ Kulissenhoehe, Kulissenlaenge }) {
  return ((Kulissenhoehe/1000)*(Kulissenlaenge/1000) * 5.3);
}

export function calculateKulissengewicht(props) {
  switch (props.Kulissentyp) {
    case "HKS":
      return (parseFloat(calculateMasseMineralwolle(props)) + parseFloat(calculateMasseKulissenrahmen(props)) + parseFloat(calculateMasseStreben(props)));
    case "HKR":
      return (parseFloat(calculateMasseMineralwolle(props)) + parseFloat(calculateMasseKulissenrahmen(props)) + parseFloat(calculateMasseStreben(props)) + parseFloat(calculateMasseResonanzblech(props)));
    case "HKL":
      return (parseFloat(calculateMasseMineralwolle(props)) + parseFloat(calculateMasseKulissenrahmen(props)) + parseFloat(calculateMasseStreben(props)) + parseFloat(calculateMasseLochblech(props)) * 2);
    case "HKRL":
      return (parseFloat(calculateMasseMineralwolle(props)) + parseFloat(calculateMasseKulissenrahmen(props)) + parseFloat(calculateMasseStreben(props)) + parseFloat(calculateMasseLochblech(props)) + parseFloat(calculateMasseResonanzblech(props)));
    case "HKRR":
      return (parseFloat(calculateMasseMineralwolle(props)) + parseFloat(calculateMasseKulissenrahmen(props)) + parseFloat(calculateMasseStreben(props)) + parseFloat(calculateMasseResonanzblech(props)) * 2);
    default:
      return -9999999999;
  }
}

export function calculateLaengeRahmenprofil({ Lueftungskanalbreite, Lueftungskanalhoehe }) {
  let laengerahmenprofil = ((Lueftungskanalbreite/1000 + Lueftungskanalhoehe/1000) * 2);
  return laengerahmenprofil;
}

export function calculateProfilgroesse({
  Lueftungskanalbreite,
  Lueftungskanalhoehe,
  Druckbereich,
  SelectedAnschlussprofil,
  CheckedAnschlussprofil,
}) {
  let laengsteSeite = calculateLaengsteSeite([Lueftungskanalbreite, Lueftungskanalhoehe]);
  let profil = "";
  switch (Druckbereich) {
    case "ND" :
      if(laengsteSeite <= 1000){
        profil = "SBM20";
      }
      else if(laengsteSeite > 1000 && laengsteSeite <=2000) {
        profil = "SBM30";
      }
      else if(laengsteSeite >2000){
        profil = "SBM40";
      }
      break;
    case "MD" :
      if(laengsteSeite <= 1000){
        profil = "SBM20";
      }
      else if(laengsteSeite > 1000 && laengsteSeite <=2000) {
        profil = "SBM30";
      }
      else if(laengsteSeite >2000){
        profil = "SBM40";
      }
      break;
    case "HD":
      if(laengsteSeite <= 1500){
        profil = "WER30";
      }
      else if(laengsteSeite >1500){
        profil = "WER40";
      }
      break;
    default:
      if(laengsteSeite <= 1500){
        profil = "WER30";
      }
      else if(laengsteSeite >1500){
        profil = "WER40";
      }
      break;
  }

  if(CheckedAnschlussprofil){
    return SelectedAnschlussprofil;
  }
  else{
    return profil;
  }
}

export function calculateGewichtEcke(props) {
  let profilgroesse = calculateProfilgroesse(props);
  switch(profilgroesse){
    case "SBM20":
      return 0.051;
    case "SBM30":
      return 0.113;
    case "SBM40":
      return 0.182;
    case "WER30":
      return 0.04;
    case "WER40":
      return 0.097;
    case "WER50":
      return 0.119;
    default:
      return undefined;
  }
}

export function calculateGewichtProfil(props) {
  let profilgroesse = calculateProfilgroesse(props);
  switch(profilgroesse){
    case "SBM20":
      return 0.51;
    case "SBM30":
      return 0.72;
    case "SBM40":
      return 1.32;
    case "WER30":
      return 1.36;
    case "WER40":
      return 2.42;
    case "WER50":
      return 3.77;
    default:
      return undefined;
  }
}

export function calculateRahmenprofilgewicht(props) {
  let masseRahmen = ((calculateLaengeRahmenprofil(props) * calculateGewichtProfil(props))+(4* calculateGewichtEcke(props)));
  return masseRahmen;
}

export function calculateGesamtgewicht(props) {
  return calculateLueftungsgehaeusegewicht({
    Lueftungskanalbreite: props.Schalldaempferbreite,
    Lueftungskanellaenge: props.Schalldaempferlaenge,
    Lueftungskanalhoehe: props.Schalldaempferhoehe,
    Druckbereich: props.Druckbereich,
  }) + (calculateKulissengewicht({
    Kulissenbreite: props.Kulissenbreite,
    Kulissenlaenge: props.Kulissenlaenge,
    Kulissenhoehe: props.Kulissenhoehe,
    Kulissentyp: props.Kulissentyp,
  }) * props.Kulissenanzahl) + calculateRahmenprofilgewicht({
    Lueftungskanalbreite: props.Schalldaempferbreite,
    Lueftungskanalhoehe: props.Schalldaempferhoehe,
    Druckbereich: props.Druckbereich,
    SelectedAnschlussprofil: props.SelectedAnschlussprofil,
    CheckedAnschlussprofil: props.CheckedAnschlussprofil,
  }) + calculateRahmenprofilgewicht({
    Lueftungskanalbreite: props.Schalldaempferbreite,
    Lueftungskanalhoehe: props.Schalldaempferhoehe,
    Druckbereich: props.Druckbereich,
    SelectedAnschlussprofil: props.SelectedAnschlussprofil,
    CheckedAnschlussprofil: props.CheckedAnschlussprofil,
  });
}
